window.Vue = require('vue');
import Vue from 'vue';
import VeeValidate from 'vee-validate';

const vee_config = require('./vee-config.js');

Vue.use(VeeValidate, vee_config);

const app = new Vue({
    el: '#app',
    mounted: function() {
        this.initJS();
    },
    data: {
        showMobileMenu: false,
        showDisclaimer: false,
        gmtvForm: {
            vinTab: 0,
            is_replacing: 0,
            has_payoff: 0,
            is_lease: 0,
            payoff_amount: null,
            vhr: '',
            selected_options: [],
            needs_repairs: 0,
            photos: [],
            response: '',
            have_factory_hp_options: 0,
            is_options_documented: 0,
            is_matching_numbers_correct: 0,
            vehicle_type: '',
            horse_power: '',
            has_been_restored: 0,
            has_been_shown:0,
            has_rust: 0
        },
        dragover: false,
        photos_to_upload: [],
        photos_uploaded: [],
        photos_uploaded_names: [],
    },

    methods: {
        initJS : function(){
            let is_dealer = $('#app').data('isDealerSite');
            if (is_dealer) {
                this.gmtvForm.vinTab = 1;
            }

            if (this.gmtvForm.vinTab) {
                this.vinTransitionEnter();
            }

            autosize($('textarea'));
            $('#vin-icon').popover({
                html : true,
                trigger: 'hover',
                placement: 'auto',
                content: function() {
                  return $("#vin-popover").html();
                },
            });

            let preselected = [];
            $('input[name="selected_options[]"][checked="checked"]').each(function(index){
                preselected.push($(this).val());
            });
            this.gmtvForm.selected_options = this.gmtvForm.selected_options.concat(preselected);

            document.addEventListener('VinFoundEvent', this.vinFound, false);

        },
        format: function(e, formatter) {
            //console.log(formatter);
            //console.log(e);
            let target = e.target;
            switch (formatter) {
                case 'vin':
                    target.value = formatters.vin(target.value);
                    break;
                case 'allcaps':
                    target.value = formatters.allCaps(target.value);
                    break;
                case 'digits':
                    target.value = formatters.digits(target.value);
                    break;
                case 'dollars':
                    target.value = formatters.dollars(target.value);
                    break;
                case 'name':
                    target.value = formatters.name(target.value);
                    break;
                case 'phone':
                    target.value = formatters.phone(target.value);
                    break;
                default:

            }
        },
        addFiles: function(e) {
            this.dragover = false;
            let files = e.target.files || e.dataTransfer.files;
            let promises = [];
            for (let i = 0; i < files.length; i++) {

                let cur_file = files[i];
                let vueApp = this;
                let new_upload = {name: cur_file.name, error: null};

                this.photos_to_upload.push(new_upload);

                if (cur_file.size > 5 * Math.pow(10, 6) ) {
                    $("#submit_details_form").attr('disabled', '');
                    new_upload.error = 'Photo must be under 5 MB';
                    vueApp.photos_to_upload = _.reject(vueApp.photos_to_upload, function(el) {
                        return el.name == cur_file.name && el.error == null;
                    });

                    continue;
                }

                let photo_promise = this.upload(cur_file);

                photo_promise.then(function (response) {
                    // handle success
                    if (response.error) {
                        new_upload.error = response.error;
                    } else if (response.data.error) {
                        new_upload.error = response.data.error;
                    } else if (response.data.photo_url) {
                        vueApp.photos_uploaded.push(response.data.photo_url);
                        vueApp.photos_uploaded_names.push(response.data.photo_name);
                    }

                }).catch(function (error) {
                    $("#submit_details_form").attr('disabled', '');
                    // handle error
                    if (error.response) {
                        // The request was made and the server responded with a status code
                        // that falls out of the range of 2xx
                        let error_message = 'Unknown error occured during upload';
                        if (error.response.data.errors.photo[0] != "undefined") {
                            error_message = error.response.data.errors.photo[0];
                        } else if (error.response.data.message != "undefined") {
                            error_message = error.response.data.message;
                        }

                        new_upload.error = error.response.data.errors.photo[0];

                    } else if (error.request) {
                        // The request was made but no response was received
                        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                        // http.ClientRequest in node.js
                        new_upload.error = 'Unknown error occured during upload';
                    } else {
                        // Something happened in setting up the request that triggered an Error
                        //alert(error.message);
                        new_upload.error = response.data.error;
                    }

                }).finally(function () {
                    //Remove from photos_to_upload by file.name
                    vueApp.photos_to_upload = _.reject(vueApp.photos_to_upload, function (el) {
                        return el.name == cur_file.name && el.error == null;
                    });
                });
            }
        },
        removeError: function(photoName){
            this.photos_to_upload = _.reject(this.photos_to_upload, function (el) {
                return el.name == photoName;
            });

            if (this.photos_to_upload.length === 0) {
                $("#submit_details_form").removeAttr('disabled');
            }
        },
        upload: async function(file) {
            let form_data = new FormData();
            form_data.append('photo', file, file.name);

            let ajax_config = {
                url: '/photos',
                method: 'post',
                data: form_data,
                responseType: 'json',
                headers: {
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                    'Content-Type': 'multipart/form-data; boundary=${data._boundary}',
                }
            };
            return await axios(ajax_config);
        },
        formSubmit: function(e) {
            this.$validator.validate().then(valid => {
                if (!valid) {
                    e.preventDefault();
                }
            });
        },
        formSubmitWithCallback: function(e, callback = () => {}) {
            this.$validator.validate().then(valid => {
                if (!valid) {
                    e.preventDefault();
                } else {
                    callback()
                }
            });
        },
        startScan: function(e) {
            e.preventDefault();
            $('#scanner-modal').modal('show');
        },
        vinTransitionEnter: function(el, done){
            if(window.scanner_loaded){
                $('#scanner-button').show();
            }
            $('#vin-icon').popover({
                html : true,
                trigger: 'hover',
                placement: 'auto',
                content: function() {
                  return $("#vin-popover").html();
                },
            });
        },
        vinFound: function(e){
            $('#vin').val(e.vin);
            $('#barcode').val(1);
        }
    },
});



// WEBPACK FOOTER //
// ./resources/js/vue-app.js